import * as React from 'react'

import { CircularProgress } from '../../atoms'
import { useCallback } from 'react'
import { CompleteAppointmentProps } from './typing'
import { useCompleteAppointment } from './hooks'
import Box from '@mui/material/Box'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import DialogContentText from '@mui/material/DialogContentText'

export function CompleteAppointmentDialog(props: CompleteAppointmentProps) {
  const { onClose, appointmentId, entityId, entityType } = props

  const { status, execute } = useCompleteAppointment(props)
  const disabled = status === 'pending'

  const handleMarkCompleted = useCallback(() => {
    if (appointmentId) {
      execute({
        entityId,
        entityType,
        appointmentId,
        requestInput: {
          notServicedReason: undefined,
        },
      })
    }
  }, [appointmentId, entityId, entityType, execute])

  return status === 'pending' ? (
    <Box height="80px" display="flex">
      <CircularProgress color="primary" />
    </Box>
  ) : (
    <Box>
      <DialogTitle>Mark As Completed</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-slide-description"
          style={{ fontSize: 14 }}
        >
          Are you sure you want to complete the appointment?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          disabled={disabled}
          color="primary"
          variant="text"
        >
          Cancel
        </Button>

        <Button
          onClick={handleMarkCompleted}
          disabled={disabled}
          color="primary"
        >
          Mark As Completed
        </Button>
      </DialogActions>
    </Box>
  )
}
